import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import bgImage from "assets/img/background-login.jpg";
import logoImage from "assets/img/dummy-logo.png";
import configData from "../../../src/config.json";
import { ToastContainer, toast } from "react-toastify";

function Register(props) {
  const [user, setUser] = useState({
    Id: 0,
    FirstName: "",
    LastName: "",
    EmailAddress: "",
    Password: "",
    RoleId: 1,
  });
  const history = useHistory();

  const onInputChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const bindHeader = () => {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Accept", "application/json");
    headers.append("Access-Control-Allow-Origin", configData.API_URL);
    headers.append("Access-Control-Allow-Credentials", "true");
    return headers;
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    let headers = bindHeader();
    await fetch(`${configData.API_URL}/api/drivers`, {
      method: "POST",
      body: JSON.stringify(user),
      headers: headers,
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
            toast.success("User saved!!!");
          setTimeout(() => {
            history.push("/login");
          }, 1000);
        } else {
            toast.error(res.message);
        }
      });
  };

  return (
    <>
      <ToastContainer />
      <div>
        <div class="wrapper wrapper-full-page">
          <div class="full-page section-image" filter-color="blue">
            <div class="content">
              <div class="login-page">
                <div class="container">
                  <div class="ml-auto mr-auto col-12 col-md-8 col-lg-4">
                    <form class="">
                      <div class="card-login card-plain card">
                        <div class="card-header">
                          <div class="logo-container">
                            <img src={logoImage} />
                          </div>
                        </div>
                        <div class="card-body">
                          <div class="no-border form-control-lg  input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="now-ui-icons users_circle-08"></i>
                              </span>
                            </div>
                            <input
                              name="FirstName"
                              placeholder="First Name"
                              type="text"
                              class="form-control"
                              onChange={(e) => onInputChange(e)}
                            />
                          </div>
                          <div class="no-border form-control-lg  input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="now-ui-icons users_circle-08"></i>
                              </span>
                            </div>
                            <input
                              name="LastName"
                              placeholder="Last Name"
                              type="text"
                              class="form-control"
                              onChange={(e) => onInputChange(e)}
                            />
                          </div>
                          <div class="no-border form-control-lg  input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="now-ui-icons users_circle-08"></i>
                              </span>
                            </div>
                            <input
                              name="EmailAddress"
                              placeholder="EmailAddress"
                              type="email"
                              class="form-control"
                              onChange={(e) => onInputChange(e)}
                            />
                          </div>
                          <div class="no-border form-control-lg  input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">
                                <i class="now-ui-icons text_caps-small"></i>
                              </span>
                            </div>
                            <input
                              name="Password"
                              placeholder="Password"
                              type="password"
                              class="form-control"
                              onChange={(e) => onInputChange(e)}
                            />
                          </div>
                        </div>
                        <div class="card-footer">
                        <button
                          type="button"
                          class="mb-3 btn-round btn btn-primary btn-lg btn-block"
                          onClick={(e) => submitHandler(e)}
                        >
                          Create Account
                        </button>
                          <div class="pull-right">
                            <h6>
                              <Link
                                class="link footer-link"
                                onClick={(e) => {
                                  history.push("/login");
                                }}
                              >
                                Go to Login
                              </Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="full-page-background"
              style={{
                backgroundImage: `url('${bgImage}')`,
              }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Register;
